var paragraph_default = {
  "fontElementMap": "MHt4h",
  "elementSpacing": "_6m6GM",
  "text": "FE-uk _6m6GM",
  "child": "_4fqav"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
